import React from "react";
import { Card, Form, Button, Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";

export default function Confidentialite() {
    const [settings, setSettings] = React.useState({
        notifications_email: true,
        partage_donnees: false,
        cookies: true
    });

    const handleToggle = (key) => {
        setSettings(prev => ({ ...prev, [key]: !prev[key] }));
    };

    return (
        <>
            <Header />
            <div className="main main-app p-3 p-lg-4">
                <div className="container-fluid">
                    <h1 className="page-title mb-4">
                        <i className="ri-lock-line me-2"></i>
                        Confidentialité
                    </h1>

                    <Card className="border-0 shadow-sm">
                        <Card.Body className="p-4">
                            <Alert variant="info">
                                <i className="ri-information-line me-2"></i>
                                Vos données sont protégées et ne sont jamais partagées sans votre consentement.
                            </Alert>

                            <h5 className="mb-3">Paramètres de confidentialité</h5>
                            
                            <div className="mb-4">
                                <Form.Check 
                                    type="switch"
                                    id="notifications-email"
                                    label="Recevoir des notifications par email"
                                    checked={settings.notifications_email}
                                    onChange={() => handleToggle('notifications_email')}
                                />
                                <Form.Text className="text-muted">
                                    Recevez des alertes pour les stocks bas, nouvelles commandes, etc.
                                </Form.Text>
                            </div>

                            <div className="mb-4">
                                <Form.Check 
                                    type="switch"
                                    id="partage-donnees"
                                    label="Partager les données anonymisées"
                                    checked={settings.partage_donnees}
                                    onChange={() => handleToggle('partage_donnees')}
                                />
                                <Form.Text className="text-muted">
                                    Aidez-nous à améliorer l'application en partageant des données d'utilisation.
                                </Form.Text>
                            </div>

                            <div className="mb-4">
                                <Form.Check 
                                    type="switch"
                                    id="cookies"
                                    label="Autoriser les cookies"
                                    checked={settings.cookies}
                                    onChange={() => handleToggle('cookies')}
                                />
                                <Form.Text className="text-muted">
                                    Les cookies nous permettent de maintenir votre session.
                                </Form.Text>
                            </div>

                            <hr />

                            <h5 className="mb-3">Politique de confidentialité</h5>
                            <p className="text-muted">
                                Consultez notre politique de confidentialité pour plus d'informations 
                                sur la façon dont nous protégeons vos données.
                            </p>
                            <Link to="#" className="btn btn-outline-primary">
                                <i className="ri-file-text-line me-2"></i>
                                Lire la politique
                            </Link>
                        </Card.Body>
                    </Card>
                </div>
                <Footer />
            </div>
        </>
    );
}